import React from 'react';
import { motion } from 'framer-motion';

const Avatar = ({ type = 'robot', color = '#FF6B6B', size = 'md', animate = true, customImage = null }) => {
  const sizes = {
    sm: 'w-12 h-12',
    md: 'w-20 h-20',
    lg: 'w-32 h-32',
    xl: 'w-48 h-48',
  };

  const getDefaultAvatarUrl = () => {
    // Use the app's default avatar
    return '/avatar.png';
  };

  const avatarContent = (
    <div
      className={`${sizes[size]} rounded-full overflow-hidden border-4 border-primary/30 shadow-neon bg-background-paper`}
    >
      {customImage ? (
        <img src={customImage} alt="Avatar" className="w-full h-full object-cover" />
      ) : (
        <img src={getDefaultAvatarUrl()} alt={`Avatar ${type}`} className="w-full h-full object-contain p-2" />
      )}
    </div>
  );

  if (animate) {
    return (
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        whileHover={{ scale: 1.1, rotate: 5 }}
        transition={{ type: 'spring', stiffness: 260, damping: 20 }}
      >
        {avatarContent}
      </motion.div>
    );
  }

  return avatarContent;
};

export default Avatar;